import { defineStore } from "pinia";
import { ref, markRaw } from "vue";
import router from "@/routers/index.js";

let modalId = 0;
let scrollLocks = 0; // счётчик модалок, блокирующих скролл

export const useModalStore = defineStore("modal", () => {
  const modals = ref([]);

  const lockBodyScroll = () => {
    if (++scrollLocks === 1) {
      document.body.style.overflow = "hidden";
    }
  };

  const unlockBodyScroll = () => {
    if (--scrollLocks === 0) {
      document.body.style.overflow = "";
    }
  };

  const openModal = ({ component, props = {}, options = {} }) => {
    const id = modalId++;
    modals.value.push({
      id,
      component: markRaw(component),
      props,
      lockScroll: options.lockScroll || false,
    });

    if (options.lockScroll) {
      lockBodyScroll();
    }

    return id;
  };

  const closeModal = (id) => {
    const modal =
      id !== undefined
        ? modals.value.find((m) => m.id === id)
        : modals.value[modals.value.length - 1];

    if (id !== undefined) {
      modals.value = modals.value.filter((m) => m.id !== id);
    } else {
      modals.value.pop();
    }

    if (modal?.lockScroll) {
      unlockBodyScroll();
    }

    const route = router.currentRoute.value;

    if (
      route.meta.isModal &&
      modals.value.length === 0 &&
      router.currentRoute.value.name !== "Profile"
    ) {
      router.back();
    }
  };

  const closeAllModals = () => {
    scrollLocks = 1;
    unlockBodyScroll();

    const modalElements = document.querySelectorAll("[data-modal-container]");
    modalElements.forEach((element) => {
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });
  };

  return { modals, openModal, closeModal, closeAllModals };
});
